import {Model} from "vue-mc";

export class Order extends Model
{


  defaults() {
    return {
      id: null,
      paymentSource: null,
    }
  }
}
